var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import React, { useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { MarketSection, MyAssetsTab, RoutePath, generateRoutePath } from '../../app/router/config';
import Filters from '../../components/filters';
import Header from '../../components/market/header';
import MobileToolbar from '../../components/market/mobile-toolbar';
import Toolbar from '../../components/market/toolbar';
import OffersTable from '../../components/my-assets/offers-table';
import AssetsGrid from '../../components/my-assets/assets-grid';
import OnSaleGrid from '../../components/my-assets/on-sale-grid';
import { UserContext } from '../../context/user';
import { useFilters } from '../../hooks/common/use-filters';
import { ItemsOrderBy } from '../../hooks/market/use-items';
import { AssetsOrderBy } from '../../hooks/market/use-my-assets';
import Layout from '../../layout';
export default function MyAssets() {
    var selectedWallet = useContext(UserContext).selectedWallet;
    var t = useI18n().t;
    var _a = useParams(), section = _a.section, tab = _a.tab;
    var navigate = useNavigate();
    var filters = useFilters({ tab: tab, section: section });
    if (!selectedWallet) {
        navigate("".concat(generateRoutePath(RoutePath.ROOT, {}), "?next=").concat(encodeURIComponent(window.location.href)));
    }
    if ((!section || !Object.values(MarketSection).includes(section)) &&
        (!tab || !Object.values(MyAssetsTab).includes(tab))) {
        navigate(generateRoutePath(RoutePath.MY_ASSETS, { section: MarketSection.CARDS, tab: MyAssetsTab.ALL }));
        return _jsx(_Fragment, {});
    }
    if (!section || !Object.values(MarketSection).includes(section)) {
        navigate(generateRoutePath(RoutePath.MY_ASSETS, { section: MarketSection.CARDS, tab: tab }));
        return _jsx(_Fragment, {});
    }
    if (!tab || !Object.values(MyAssetsTab).includes(tab)) {
        navigate(generateRoutePath(RoutePath.MY_ASSETS, { section: section, tab: MyAssetsTab.ALL }));
        return _jsx(_Fragment, {});
    }
    var sectionsLinks = [
        {
            label: t('market.token-type.cards'),
            path: generateRoutePath(RoutePath.MY_ASSETS, { section: MarketSection.CARDS, tab: tab }),
            selected: section === MarketSection.CARDS,
        },
        {
            label: t('market.token-type.mint-passes'),
            path: generateRoutePath(RoutePath.MY_ASSETS, { section: MarketSection.MINT_PASSES, tab: tab }),
            selected: section === MarketSection.MINT_PASSES,
        },
        {
            label: t('market.token-type.arise'),
            path: generateRoutePath(RoutePath.MY_ASSETS, { section: MarketSection.ARISE, tab: tab }),
            selected: section === MarketSection.ARISE,
        },
        {
            label: t('market.token-type.lands'),
            path: generateRoutePath(RoutePath.MY_ASSETS, { section: MarketSection.LANDS, tab: tab }),
            selected: section === MarketSection.LANDS,
            disabled: true,
        },
    ];
    var tabs = [
        {
            label: t('my-assets.tabs.all'),
            path: generateRoutePath(RoutePath.MY_ASSETS, { section: section, tab: MyAssetsTab.ALL }),
            selected: tab === MyAssetsTab.ALL,
        },
        {
            label: t('my-assets.tabs.on-sale'),
            path: generateRoutePath(RoutePath.MY_ASSETS, { section: section, tab: MyAssetsTab.ON_SALE }),
            selected: tab === MyAssetsTab.ON_SALE,
        },
        {
            label: t('my-assets.tabs.offers'),
            path: generateRoutePath(RoutePath.MY_ASSETS, { section: section, tab: MyAssetsTab.OFFERS }),
            selected: tab === MyAssetsTab.OFFERS,
        },
        {
            label: t('my-assets.tabs.history'),
            path: generateRoutePath(RoutePath.MY_ASSETS, { section: section, tab: MyAssetsTab.HISTORY }),
            selected: tab === MyAssetsTab.HISTORY,
            disabled: true,
        },
    ];
    function getOrderByOptions() {
        if (tab === MyAssetsTab.ALL) {
            return [
                {
                    label: t('order-by.name'),
                    value: AssetsOrderBy.NAME,
                },
                {
                    label: t('order-by.date'),
                    value: AssetsOrderBy.DATE,
                },
            ];
        }
        if (tab === MyAssetsTab.ON_SALE) {
            return [
                {
                    label: t('order-by.price'),
                    value: ItemsOrderBy.PRICE,
                },
                {
                    label: t('order-by.date'),
                    value: ItemsOrderBy.DATE,
                },
            ];
        }
        return [];
    }
    return (_jsx(Layout, { fullWidth: true, children: _jsxs(_Fragment, { children: [_jsx(Header, { assets: true, sectionsLinks: sectionsLinks }), _jsx(Filters, { filters: filters, marketTokenType: section, showCurrencyToken: tab === MyAssetsTab.ON_SALE || tab === MyAssetsTab.OFFERS }), _jsx(Toolbar, { direction: filters.state.direction, orderBy: tab === MyAssetsTab.ALL || tab === MyAssetsTab.ON_SALE ? filters.state.orderBy : undefined, orderByOptions: tab === MyAssetsTab.ALL || tab === MyAssetsTab.ON_SALE ? getOrderByOptions() : undefined, searchQuery: filters.state.searchQuery, setDirection: tab === MyAssetsTab.ALL || tab === MyAssetsTab.ON_SALE ? filters.actions.setDirection : undefined, setOrderBy: tab === MyAssetsTab.ALL || tab === MyAssetsTab.ON_SALE ? filters.actions.setOrderBy : undefined, tabs: tabs }), _jsx(MobileToolbar, { direction: filters.state.direction, orderBy: filters.state.orderBy, orderByOptions: getOrderByOptions(), searchQuery: filters.state.searchQuery, setDirection: filters.actions.setDirection, setOrderBy: filters.actions.setOrderBy }), _jsxs(Container, { children: [tab === MyAssetsTab.ALL && (_jsx(AssetsGrid, { filters: filters, section: section, tokenType: filters.state.tokenTypes[0] })), tab === MyAssetsTab.ON_SALE && (_jsx(OnSaleGrid, { filters: filters, section: section, tokenType: filters.state.tokenTypes[0] })), tab === MyAssetsTab.OFFERS && (_jsx(OffersTable, { filters: filters, section: section, tokenType: filters.state.tokenTypes[0] }))] })] }) }));
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  overflow: auto;\n  width: 100%;\n\n  & > div {\n    flex-shrink: 0;\n  }\n"], ["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  overflow: auto;\n  width: 100%;\n\n  & > div {\n    flex-shrink: 0;\n  }\n"])));
var templateObject_1;
